import { render } from "./Language.vue?vue&type=template&id=125430e7"
import script from "./Language.vue?vue&type=script&lang=ts"
export * from "./Language.vue?vue&type=script&lang=ts"
script.render = render

export default script